// French (fr)
export default {
  // --- Shell / nav ---
  app_name: 'Marées proches de moi',
  search_stations: 'Rechercher des stations',
  search_stations_hint: 'Rechercher des stations (⌘K)',
  settings: 'Réglages',
  app_store: "Télécharger dans l'App Store",
  google_play: 'Disponible sur Google Play',
  app_promo_title: "Téléchargez l'app gratuite. Elle est plus rapide 🙂",
  app_promo_body: 'Les mêmes prévisions de marées et de courants, sur votre téléphone.',
  privacy: 'Confidentialité',
  terms: 'Conditions',
  data_sources: 'Sources de données',
  support: 'Support',

  guides: 'Guides',
  // --- Home ---
  home_title: 'Trouvez les marées et courants à proximité',
  by_country: 'Par pays',
  favorite_tides: 'Marées préférées',
  recent_tides: 'Marées récentes',
  nearby_tides: 'Marées à proximité',
  favorite_currents: 'Courants préférés',
  recent_currents: 'Courants récents',
  nearby_currents: 'Courants à proximité',
  favorite_charts: 'Cartes marines préférées',
  recent_charts: 'Cartes marines récentes',
  nearby_charts: 'Cartes marines à proximité',
  finding_stations: 'Recherche de stations près de vous…',
  distance_away: 'À {{distance}}',

  // --- Search overlay ---
  search_placeholder: 'Rechercher des stations…',
  tide_stations: 'Stations de marée',
  current_stations: 'Stations de courant',
  recents: 'Récent',
  search_unavailable: 'La recherche est indisponible pour le moment.',
  no_stations_found: 'Aucune station trouvée.',
  search_prompt: 'Recherchez des stations de marée et de courant par nom.',

  // --- Settings ---
  appearance: 'Apparence',
  appearance_system: 'Système',
  appearance_light: 'Clair',
  appearance_dark: 'Sombre',
  tide_height: 'Hauteur de marée',
  unit_feet: 'Pieds',
  unit_meters: 'Mètres',
  distance: 'Distance',
  unit_miles: 'Miles',
  unit_kilometers: 'Kilomètres',
  recent_stations: 'Stations récentes',
  clear_recents: 'Effacer les récents',
  currents: 'Courants',
  nautical_charts: 'Cartes marines',
  browse_by_country: 'Parcourir par pays',
  countries_auto: 'Auto',
  countries_always: 'Toujours',
  countries_never: 'Jamais',
  show: 'Afficher',
  hide: 'Masquer',

  // --- Station pages (tide + current) ---
  tide_title: 'Marées de {{name}}',
  current_title: 'Courants de {{name}}',
  last_tide: 'Dernière marée',
  next_tide: 'Prochaine marée',
  coefficient: 'Coef',
  last_current: 'Dernier courant',
  next_current: 'Prochain courant',
  following_current: 'Courant suivant',
  high: 'Haute',
  low: 'Basse',
  tides: 'Marées',
  sun: 'Soleil',
  moon: 'Lune',
  sunrise_now: 'Lever du soleil',
  sunset_now: 'Coucher du soleil',
  moonrise_now: 'Lever de lune',
  moonset_now: 'Coucher de lune',
  sunrise_week: 'Lever',
  sunset_week: 'Coucher',
  moonrise_week: 'Lever',
  moonset_week: 'Coucher',
  add_to_favorites: 'Ajouter aux favoris',
  remove_from_favorites: 'Retirer des favoris',

  // --- Week table dates ---
  today: "Aujourd'hui",
  tomorrow: 'Demain',

  // --- Moon phases ---
  phase_new_moon: 'Nouvelle lune',
  phase_waxing_crescent: 'Premier croissant',
  phase_first_quarter: 'Premier quartier',
  phase_waxing_gibbous: 'Lune gibbeuse croissante',
  phase_full_moon: 'Pleine lune',
  phase_waning_gibbous: 'Lune gibbeuse décroissante',
  phase_last_quarter: 'Dernier quartier',
  phase_waning_crescent: 'Dernier croissant',

  // --- Tide / current status vocabulary ---
  rising: 'Montante',
  falling: 'Descendante',
  high_tide: 'Pleine mer',
  low_tide: 'Basse mer',
  ebb: 'Jusant',
  flood: 'Flot',
  slack: 'Étale',

  // --- Relative time (separate singular/plural keys, native-style) ---
  just_now: "À l'instant",
  somethings_wrong: "Une erreur s'est produite",
  hour_ago: 'Il y a {{hour}} heure',
  hours_ago: 'Il y a {{hour}} heures',
  minute_ago: 'Il y a {{minute}} minute',
  minutes_ago: 'Il y a {{minute}} minutes',
  hour_minute_ago: 'Il y a {{hour}} heure et {{minute}} minute',
  hour_minutes_ago: 'Il y a {{hour}} heure et {{minute}} minutes',
  hours_minute_ago: 'Il y a {{hour}} heures et {{minute}} minute',
  hours_minutes_ago: 'Il y a {{hour}} heures et {{minute}} minutes',
  hour_from_now: 'Dans {{hour}} heure',
  hours_from_now: 'Dans {{hour}} heures',
  minute_from_now: 'Dans {{minute}} minute',
  minutes_from_now: 'Dans {{minute}} minutes',
  hour_minute_from_now: 'Dans {{hour}} heure et {{minute}} minute',
  hour_minutes_from_now: 'Dans {{hour}} heure et {{minute}} minutes',
  hours_minute_from_now: 'Dans {{hour}} heures et {{minute}} minute',
  hours_minutes_from_now: 'Dans {{hour}} heures et {{minute}} minutes',

  // --- Insights ---
  insights_7_day_overview: 'Aperçus de 7 jours',
  no_insights_available: 'Aucun aperçu disponible pour cette station.',
  insights_current_extremes: 'Extrêmes de courant',
  insights_fastest_flood: 'Flot le plus rapide',
  insights_fastest_ebb: 'Jusant le plus rapide',
  insights_strongest_daily_currents: 'Courants journaliers maximaux',
  insights_fastest_current: 'Plus rapide',
  insights_slowest_current: 'Plus lent',
  insights_tidal_extremes: 'Extrêmes de marée',
  insights_highest_tide: 'Marée la plus haute',
  insights_lowest_tide: 'Marée la plus basse',
  insights_strongest_daily_movements: 'Plus grands marnages',
  insights_largest_tide: 'Plus grand',
  insights_smallest_tide: 'Plus petit',
  insights_value_at_time: '{{value}} à {{time}}',
  insights_tidal_range_label: 'marnage',
  insights_max_current_label: 'courant max',

  // --- Insight bands ---
  band_smaller_than_usual: "Plus petit que d'habitude",
  band_typical: 'Typique',
  band_larger_than_usual: "Plus grand que d'habitude",
  band_unusually_large: 'Inhabituellement grand',
  band_lower_than_usual: "Plus basse que d'habitude",
  band_unusually_low: 'Exceptionnellement basse',
  band_slower_than_usual: "Plus lent que d'habitude",
  band_faster_than_usual: "Plus rapide que d'habitude",
  band_unusually_fast: 'Inhabituellement rapide',
  band_smaller_than_usual_height: "Plus bas que d'habitude",
  band_larger_than_usual_height: "Plus haut que d'habitude",
  band_unusually_large_height: 'Inhabituellement haut',

  // --- Map attribution ---
  attribution: 'Attribution',
  attribution_osm: 'Données cartographiques © contributeurs OpenStreetMap',
  attribution_tiles: 'Tuiles cartographiques par OpenFreeMap',
  attribution_style: 'Style de carte © OpenMapTiles',
  ok: 'OK',

  // --- Explore map ---
  current_speed: 'Vitesse du courant',
  depth: 'Profondeur',
  speed: 'Vitesse',
  depth_datum: 'Profondeurs depuis',
  depth_drying: 'Découvre',
  depth_loading: 'Chargement des données de profondeur…',
  depth_datum_tag: 'Profondeurs en {{unit}} sous {{datum}}',
  depth_not_for_navigation: 'Ne pas utiliser pour la navigation.',
  depth_unavailable: 'Les données de profondeur sont indisponibles pour le moment.',
  depth_unit_m: 'm',
  depth_unit_ft: 'ft',
  go_mode_start: 'GO',
  go_mode_start_label: 'Démarrer le mode Go',
  go_mode_exit: 'Quitter le mode Go',
  go_mode_location_denied:
    "Le mode Go a besoin de votre position. Activez-la via l'icône de cadenas.",
  go_mode_location_denied_ok: 'OK',
  radar: 'Radar',
  radar_precipitation: 'Précipitations',
  radar_light: 'faible',
  radar_moderate: 'modérée',
  radar_heavy: 'forte',
  radar_storm: 'violente',
  radar_forecast: 'prévision',
  radar_none_for_time: 'pas de radar pour cette heure',
  now: 'Maintenant',
  explore_prompt_denied:
    "La localisation est désactivée pour ce site - activez-la via l'icône de cadenas dans la barre d'adresse.",
  open_full_map: 'Ouvrir la carte complète',
  close_full_map: 'Fermer la carte complète',
  explore_full_map: 'Explorer la carte complète',
  center_on_location: 'Centrer sur ma position',
  show_my_location: 'Afficher ma position',
  map_knots_label: '{{speed}} kt',

  // --- Location pages ---
  states: 'états',
  no_stations_found_location: 'Aucune station trouvée.',
  tides_and_currents_by_country: 'Marées et courants par pays',

  // --- SEO titles / descriptions ---
  settings_seo_description: 'Choisissez vos unités pour les hauteurs de marée et les distances.',
  tide_seo_description:
    'Prévisions de marée, horaires des pleines et basses mers pour {{name}}{{location}}.',
  current_seo_description:
    'Prévisions des courants de marée, horaires de flot et de jusant pour {{name}}{{location}}.',
  location_title: 'Marées et courants de {{name}}',
  country_seo_description:
    'Horaires de marée et prévisions des courants de marée pour {{name}}. Parcourez les {{stateTerm}} et les stations de marée côtières à travers {{name}}.',
  state_seo_description:
    'Prévisions de marées et de courants pour {{name}}, {{country}}. Horaires des pleines et basses mers pour les stations côtières de {{name}}.',
  city_seo_description:
    'Horaires de marée et prévisions des courants de marée pour {{place}}. Marées hautes et basses et courants près de {{name}}.',
  // --- Chart pages (chart titles, numbers and purposes stay in the
  // issuing authority's language: they name a specific printed sheet) ---
  charts_for_station: 'Cartes marines pour {{name}}',
  chart_intro:
    'Carte marine gratuite de {{title}} : profondeurs cartographiées, bouées, balises, roches, épaves, ports de plaisance, mouillages et stations de marées.',
  chart_page_name: 'Carte marine de {{title}}',
  chart_seo_description:
    'Carte marine gratuite de {{title}} : profondeurs cartographiées, bouées, balises, roches, épaves, ports de plaisance, mouillages et stations de marées.',

  countries_seo_title: 'Stations de marée et de courant par pays',
  countries_seo_description:
    'Parcourez les stations de marée et de courant par pays. Horaires des pleines et basses mers et prévisions des courants de marée pour les emplacements côtiers du monde entier.',
  home_seo_description:
    'Consultez les horaires de marée et les prévisions des courants de marée des stations côtières près de chez vous. Voyez les pleines et basses mers de votre position ou parcourez les stations par pays.',
  explore_play: 'Lire',
  explore_pause: 'Pause',
  explore_playback_speed: 'Vitesse de lecture',
  explore_time: 'Heure',
  skip_to_content: 'Passer au contenu principal',
  // --- Weather (station pages) ---
  weather: 'Météo marine',
  wind: 'Vent',
  gusts: 'Rafales',
  seas: 'Mer',
  time: 'Heure',
  air_temp: 'Air',
  water_temp: 'Eau',
  water_temperature: "Température de l'eau",
  humidity: 'Humidité',
  pressure: 'Pression',
  precip_chance: 'Précipitations',
  chances: 'Probabilité',
  precip_rate: 'Intensité des précipitations',
  visibility: 'Visibilité',
  condition_thunderstorms: 'Orages',
  condition_freezing_rain: 'Pluie verglaçante',
  condition_sleet: 'Grésil',
  condition_snow: 'Neige',
  condition_fog: 'Brouillard',
  condition_rain: 'Pluie',
  condition_cloudy: 'Nuageux',
  condition_partly_cloudy: 'Partiellement nuageux',
  condition_clear: 'Dégagé',
  weather_thunder: 'Orage',
  note_seas_computed_from_wind:
    'La hauteur des vagues est estimée à partir du vent et du littoral.',
  note_seas_from_nearby_open_water: 'L’état de la mer provient d’eaux libres voisines.',
  note_seas_open_water_nearby:
    "Les vagues en eau libre à proximité font environ {{height}}. Ici, l'eau peut être plus calme.",
  note_seas_open_water_distant:
    "Les vagues en eau libre à {{distance}} font environ {{height}}. Ici, l'eau peut être plus calme.",
  note_seas_open_water_distant_dir:
    "Les vagues en eau libre à {{distance}} au {{direction}} d'ici font environ {{height}}. Ici, l'eau peut être plus calme.",
  note_seas_unavailable: 'Aucun état de la mer fiable n’est disponible pour ce point.',
  note_sheltered_water_sees_less:
    'En eaux abritées, la mer est généralement moins forte que ces valeurs du large.',
  note_no_warning_feed_coverage: 'Aucun service officiel d’avis maritimes ne couvre ce point.',
  note_nearest_point_across_land:
    'Le point de prévision le plus proche est de l’autre côté des terres.',
  warnings_none_active: 'Aucun avis maritime en vigueur',
  warnings_unavailable: 'Les avis maritimes ne sont pas disponibles pour cet endroit',
  warning_show_text: 'Afficher le texte officiel',
  warning_hide_text: 'Masquer le texte officiel',
  weather_updated: 'Mis à jour {{time}}',
  current_conditions: 'Conditions actuelles',
  daily_forecast: 'Prévisions journalières',
  expand_for_hourly: 'Développer pour le détail horaire',
  hourly: 'Par heure',
  hourly_forecast: 'Prévisions horaires',
  wind_speed: 'Vitesse du vent',
  wind_gusts: 'Vent et rafales',
  pressure_humidity: 'Pression et humidité',
  max_seas: 'Mer max.',
  visibility_excellent: 'Excellente',
  visibility_good: 'Bonne',
  visibility_moderate: 'Modérée',
  visibility_poor: 'Mauvaise',
  forecaster_text_link: 'Texte de prévision {{issuer}}',
  temperature: 'Température',
  unit_fahrenheit: 'Fahrenheit',
  unit_celsius: 'Celsius',
  // --- Conditions summary (station pages) ---
  // Sea state: WMO Sea State Code. Wind: Beaufort. Both are published
  // scales with standard terminology in each language, not our own wording.
  // Warning-window and low–high range punctuation. CJK marks a range (and
  // an open end) with ～, not an en dash or a trailing plus.
  warning_window_range: '{{start}} – {{end}}',
  warning_window_open: '{{start}}+',
  range_separator_short: '-',
  // Wave-period fragments. The connector is the locale's own word for the
  // "at" in "0.5 m S @ 3s" (CJK says "period" instead); the value carries
  // the locale's seconds notation (秒/초 — bare Latin "s" reads as an
  // untranslated fragment in CJK weather products).
  seas_period_at: 'à',
  wave_period_short: '{{period}}s',
  // 16-point compass, per this locale’s meteorological convention — the
  // letters differ across languages (Z/O/Ø/V…) and CJK writes the words out.
  compass_N: 'N',
  compass_NNE: 'NNE',
  compass_NE: 'NE',
  compass_ENE: 'ENE',
  compass_E: 'E',
  compass_ESE: 'ESE',
  compass_SE: 'SE',
  compass_SSE: 'SSE',
  compass_S: 'S',
  compass_SSW: 'SSO',
  compass_SW: 'SO',
  compass_WSW: 'OSO',
  compass_W: 'O',
  compass_WNW: 'ONO',
  compass_NW: 'NO',
  compass_NNW: 'NNO',
  // Known warning types, one badge label each. Bureau-home locales use the
  // bureau’s official terminology. Unknown types fall back to the humanized
  // English code in every locale (see warningTypeLabel).
  warning_type_small_craft_advisory: 'Avis aux petites embarcations',
  warning_type_gale_warning: 'Avertissement de coup de vent',
  warning_type_gale_watch: 'Veille de coup de vent',
  warning_type_storm_warning: 'Avertissement de tempête',
  warning_type_storm_watch: 'Veille de tempête',
  warning_type_hurricane_force_wind_warning: 'Avertissement de vents de force ouragan',
  warning_type_hurricane_force_wind_watch: 'Veille de vents de force ouragan',
  warning_type_special_marine_warning: 'Avertissement maritime spécial',
  warning_type_marine_weather_statement: 'Bulletin météo maritime',
  warning_type_hazardous_seas_warning: 'Avertissement de mer dangereuse',
  warning_type_brisk_wind_advisory: 'Avis de vent vif',
  warning_type_low_water_advisory: 'Avis de basses eaux',
  warning_type_dense_fog_advisory: 'Avis de brouillard dense',
  warning_type_heavy_freezing_spray_warning: "Avertissement d'embruns verglaçants forts",
  warning_type_strong_wind_warning: 'Avertissement de vent fort',
  warning_type_gale_force_wind_warning: 'Avertissement de coup de vent',
  warning_type_storm_force_wind_warning: 'Avertissement de tempête',
  warning_type_wind_warning: 'Avertissement de vent',
  warning_type_dense_fog_warning: 'Avertissement de brouillard dense',
  warning_type_icing_warning: 'Avertissement de givrage',
  warning_type_typhoon_warning: 'Avertissement de typhon',
  warning_type_wind_wave_warning: 'Avertissement de fortes vagues',
  warning_type_wind_wave_advisory: 'Avis de fortes vagues',
  warning_type_strong_wind_advisory: 'Avis de vent fort',
  warning_type_storm_surge_warning: "Avertissement d'onde de tempête",
  warning_type_storm_surge_advisory: "Avis d'onde de tempête",
  warning_type_thunderstorm_warning: "Avertissement d'orage",
  warning_type_rough_sea_warning: 'Avertissement de mer agitée',
  warning_type_fog_warning: 'Avertissement de brouillard',
  sea_state_calm_rippled: 'Mer ridée',
  sea_state_smooth: 'Mer belle',
  sea_state_slight: 'Mer peu agitée',
  sea_state_moderate: 'Mer agitée',
  sea_state_rough: 'Mer forte',
  sea_state_very_rough: 'Mer très forte',
  sea_state_high: 'Mer grosse',
  sea_state_very_high: 'Mer très grosse',
  sea_state_phenomenal: 'Mer énorme',
  hazard_showers: 'Averses',
  hazard_reduced_visibility: 'Visibilité réduite',
  hazard_haze: 'Brume',
  hazard_waterspout: 'Trombes marines',
  hazard_freezing_spray: 'Embruns verglaçants',
  hazard_ice: 'Glace',
  marine_summary_sea_wind: '{{sea}}, vent de {{direction}} à {{speed}}.',
  marine_summary_wind_only_gusting: 'Vent de {{direction}} à {{speed}}, rafales {{gust}}.',
  marine_summary_sea_wind_gusting: '{{sea}}, vent de {{direction}} à {{speed}}, rafales {{gust}}.',
  marine_summary_wind_only: 'Vent de {{direction}} à {{speed}}.',
  marine_summary_sea_only: '{{sea}}.',
  marine_prediction_caveat_tide_one:
    'Les prédictions de marée sont astronomiques : la météo de cet avis peut donc relever ou abaisser le niveau réel.',
  marine_prediction_caveat_tide_many:
    'Les prédictions de marée sont astronomiques : la météo de ces avis peut donc relever ou abaisser le niveau réel.',
  marine_prediction_caveat_current_one:
    'Les prédictions de courant sont astronomiques : la météo de cet avis peut donc renforcer ou affaiblir le courant réel.',
  marine_prediction_caveat_current_many:
    'Les prédictions de courant sont astronomiques : la météo de ces avis peut donc renforcer ou affaiblir le courant réel.',
  marine_warning_active: 'Un avis de tempête est en vigueur pour cette zone.',
  marine_warnings_active: 'Des avis sont en vigueur pour cette zone.',
  marine_warning_upcoming: 'Un avis entre en vigueur pour cette zone {{time}}.',
  marine_warnings_upcoming: 'Des avis entrent en vigueur pour cette zone à partir du {{time}}.',
  marine_summary_hazard_now: 'En ce moment : {{hazard}}.',
  marine_summary_hazard_later: 'Prévu : {{hazard}}.',
  marine_tide_rising:
    'La marée est à {{height}} et monte : prochaine pleine mer {{next}} à {{time}}.',
  marine_tide_falling:
    'La marée est à {{height}} et descend : prochaine basse mer {{next}} à {{time}}.',
  marine_current_flood: 'Prochain flot {{speed}} à {{time}}.',
  marine_current_ebb: 'Prochain jusant {{speed}} à {{time}}.',
  marine_current_slack: 'Prochaine étale à {{time}}.',
  marine_current_now_flood: 'Le courant est au flot à {{speed}}.',
  marine_current_now_ebb: 'Le courant est au jusant à {{speed}}.',
  marine_current_now_slack: 'Le courant est étale.',
  marine_current_peak: 'Maximum {{speed}} à {{time}}.',

  // --- Chart furniture (navaid / hazard / POI click popups) ---
  // See en.js for the rules these follow. "IALA A" / "IALA B" stay untranslated
  // in every language: it is the standard's name.
  furn_light: 'Feu',
  furn_buoy: 'Bouée',
  furn_beacon: 'Balise',
  furn_wreck: 'Épave',
  furn_rock: 'Roche',
  furn_obstruction: 'Obstruction',
  furn_anchorage: 'Mouillage',
  furn_tss: 'Dispositif de séparation du trafic',
  furn_routing: 'Organisation du trafic',
  furn_title_buoy: 'Bouée {{category}}',
  furn_title_beacon: 'Balise {{category}}',
  furn_cat_port: 'bâbord',
  furn_cat_starboard: 'tribord',
  furn_cat_preferred_channel_port: 'de chenal préférentiel bâbord',
  furn_cat_preferred_channel_starboard: 'de chenal préférentiel tribord',
  furn_cat_safe_water: 'd’eaux saines',
  furn_cat_isolated_danger: 'de danger isolé',
  furn_cat_north: 'cardinale Nord',
  furn_cat_east: 'cardinale Est',
  furn_cat_south: 'cardinale Sud',
  furn_cat_west: 'cardinale Ouest',
  furn_cat_special: 'spéciale',
  furn_cat_mooring: 'de mouillage',
  furn_cat_lateral: 'latérale',
  furn_characteristic: 'Caractéristique',
  furn_range: 'Portée',
  furn_height: 'Hauteur',
  furn_colour: 'Couleur',
  furn_shape: 'Forme',
  furn_lights_on_mark: 'Feux de cette marque',
  furn_topmark: 'Voyant',
  furn_class: 'Classe',
  furn_least_depth_over: 'Profondeur minimale au-dessus',
  furn_depth_over: 'Profondeur au-dessus',
  furn_state: 'État',
  furn_type: 'Type',
  furn_range_value: '{{value}} M',
  furn_metres_value: '{{value}} m',
  furn_cable: 'Câble sous-marin',
  furn_pipeline: 'Canalisation sous-marine',
  furn_restricted_area: 'Zone réglementée',
  furn_restriction: 'Restriction',
  furn_mpa: 'Aire marine protégée',
  furn_protection: 'Protection',
  furn_agency: 'Gérée par',
  furn_mpa_note: 'Une désignation de conservation, pas une restriction de navigation.',
  furn_sector: 'Secteur',
  furn_sector_value: '{{from}}° → {{to}}°',
  lightw_f: 'Feu {{colour}} fixe.',
  lightw_fl: 'Éclats {{colour}}s toutes les {{period}} secondes.',
  lightw_fl_group: 'Éclats {{colour}}s par groupes de {{count}}, toutes les {{period}} secondes.',
  lightw_lfl: 'Un éclat long {{colour}} toutes les {{period}} secondes.',
  lightw_q: 'Scintillement {{colour}} rapide.',
  lightw_iso: 'Lumière {{colour}} et obscurité égales, toutes les {{period}} secondes.',
  lightw_oc: 'Feu {{colour}} à occultations toutes les {{period}} secondes.',
  lightcolour_white: 'blanc',
  lightcolour_red: 'rouge',
  lightcolour_green: 'vert',
  lightcolour_yellow: 'jaune',
  furn_feet_charted_value: '{{feet}} ft ({{metres}} m sur la carte)',
  furn_light_yes: 'oui',
  furn_shown_neutral: '{{colours}} (affiché en neutre)',
  furn_note_light: "Aspect du feu la nuit : c'est ainsi que le marin l'identifie.",
  furn_note_lateral_b_port:
    'Marque le côté GAUCHE du chenal en venant du large (IALA B : cylindrique verte).',
  furn_note_lateral_b_starboard:
    'Marque le côté DROIT du chenal en venant du large (IALA B : « rouge à droite en entrant »).',
  furn_note_lateral_a_port:
    'Marque le côté BÂBORD du chenal en venant du large (IALA A : rouge à bâbord).',
  furn_note_lateral_a_starboard:
    'Marque le côté TRIBORD du chenal en venant du large (IALA A : vert à tribord).',
  furn_note_safe_water:
    'Eaux saines tout autour, en général la marque d’atterrissage ou de milieu de chenal.',
  furn_note_isolated_danger: 'Mouillée sur un danger isolé entouré d’eaux navigables.',
  furn_note_cardinal_north: 'Marque cardinale : passez au NORD.',
  furn_note_cardinal_east: 'Marque cardinale : passez à l’EST.',
  furn_note_cardinal_south: 'Marque cardinale : passez au SUD.',
  furn_note_cardinal_west: 'Marque cardinale : passez à l’OUEST.',
  furn_note_special: 'Marque spéciale (jaune) : limites, câbles, mouillages, régates.',
  furn_note_preferred_starboard: 'Marque de bifurcation : le chenal préféré est à tribord.',
  furn_note_preferred_port: 'Marque de bifurcation : le chenal préféré est à bâbord.',
  furn_note_mooring: 'Bouée de mouillage.',
  furn_vessel: 'Navire',
  furn_depth_quality: 'Qualité du brassiage',
  furn_length: 'Longueur',
  furn_position_accuracy: 'Précision de position',
  furn_remarks: 'Remarques',
  furn_circumstances: 'Circonstances',
  furn_status: 'État',
  furn_note_shom: 'Cartographié par le Shom (France). ©Shom, CC BY-SA 4.0.',
  furn_lock: 'Écluse',
  furn_bridge: 'Pont',
  furn_overhead_cable: 'Câble aérien',
  furn_notice_mark: 'Panneau de signalisation',
  furn_distance_mark: 'Borne kilométrique',
  furn_daymark: 'Balise de jour',
  furn_channel: 'Chenal',
  furn_vertical_clearance_closed: "Tirant d'air (fermé)",
  furn_vertical_clearance_open: "Tirant d'air (ouvert)",
  furn_datum: 'Référence',
  furn_datum_value: '{plane} (VERDAT {code})',
  furn_datum_unknown: 'unknown code (VERDAT {code})',
  furn_note_ienc:
    "ENC fluviale (US Army Corps of Engineers). Les tirants d'air sont mesurés au-dessus de la référence indiquée ci-dessus : la hauteur libre réelle est moindre lorsque le fleuve est en crue.",
  furn_note_wreck:
    'Épave portée sur la carte. Les profondeurs sont des valeurs cartographiques, non vérifiées.',
  furn_note_anchorage: 'Zone de mouillage portée sur la carte.',
  furn_note_tss:
    'Voies de navigation à sens unique. Les petits navires les traversent perpendiculairement et se tiennent à l’écart.',
  furn_route: 'Route',
  furn_fairway: 'Chenal',
  furn_recommended_track: 'Route recommandée',
  furn_navigation_line: 'Ligne de navigation',
  furn_leading_line: 'Alignement',
  furn_clearing_line: 'Alignement de sécurité',
  furn_transit_line: 'Ligne de transit',
  furn_traffic: 'Trafic',
  furn_orientation: 'Orientation',
  furn_degrees_value: '{{value}}°',
  furn_note_fairway: 'Chenal porté sur la carte : le passage entretenu ou préférentiel.',
  furn_note_track: 'Route portée sur la carte.',
  furn_note_track_fixed_marks:
    'Route portée sur la carte, fondée sur des amers fixes (alignements).',
  furn_note_leading_line:
    'Gardez les amers d’alignement alignés pour rester sur la ligne portée sur la carte.',
  furn_note_navigation_line: 'Ligne de navigation portée sur la carte.',
  furn_poi_marina: 'Port de plaisance',
  furn_poi_fuel: 'Carburant',
  furn_poi_slipway: 'Cale de mise à l’eau',
  furn_poi_ferry_terminal: 'Terminal de ferry',
  furn_poi_boatyard: 'Chantier naval',
  furn_poi_lighthouse: 'Phare',
  furn_note_slipway: 'Cale de mise à l’eau.',
  // Layers sheet — UNTRANSLATED, English placeholders (2026-09-11). Catalog
  // parity is enforced by scripts/check-locale-keys.mjs, so a key cannot be
  // added to en.js alone; these are placeholders awaiting translation, not
  // a claim that the strings are localized.
  layers: 'Layers',
  layers_close: 'Close layers',
  layers_map_type: 'Map type',
  layers_visualizations: 'Visualizations',
  layers_standard_map: 'Standard Map',
  layers_depth_chart: 'Depth Chart',
  layers_moving_tides: 'Moving Tides',
  layers_moving_currents: 'Moving Currents',
  layers_wind_waves: 'Wind & Waves',
  layers_weather_radar: 'Weather Radar',
  layers_coming_soon: 'Coming soon',
  layers_no_currents_here: 'No current stations in view',
  layers_no_radar_here: 'No radar coverage in view',
  // The compass button's accessible name. {{point}} is a 16-point direction
  // (SSW) and {{deg}} the exact bearing — the face rounds to 8 points, this
  // does not. English placeholder in the non-English catalogs, awaiting
  // translation; catalog parity is enforced by scripts/check-locale-keys.mjs.
  follow_my_direction: 'Suivre mon orientation',
  compass_faces: 'Map faces {{point}} · {{deg}}°, tap for north-up',
  ww_row_no_data: '{{row}}: pas de données ici',
  ww_row_no_forecast_after: '{{row}}: pas de prévision après {{when}}',
  ww_row_no_forecast: '{{row}}: pas de prévision aussi loin',
  ww_unavailable: 'Météo indisponible',
  explore_show_player: 'Afficher la chronologie',
  explore_hide_player: 'Masquer la chronologie',

  // --- Route planning on /explore (2026-10-23) ---
  // Describe, never advise; never "safe". The service's own disclaimer is
  // printed verbatim from its response; route_disclaimer is only the fallback.
  // Mark nouns are all feminine (bouée, balise) so colour, "la" and
  // "lumineuse" agree; a US "light" is a balise lumineuse here.
  route_plan: 'Planifier un itinéraire',
  route_leave: "Quitter la planification d'itinéraire",
  route_title: 'Itinéraire',
  route_prompt_start: "Touchez l'eau à votre point de départ.",
  route_prompt_start_desktop:
    "Cliquez sur l'eau à votre point de départ, puis sur votre destination.",
  route_prompt_end: 'Départ défini. Touchez maintenant votre destination.',
  route_prompt_end_desktop: 'Départ défini. Cliquez maintenant sur votre destination.',
  route_drag_hint: 'Les épingles peuvent être déplacées.',
  route_clear: 'Effacer',
  route_swap: 'Inverser départ et destination',
  route_share: 'Copier le lien',
  route_copied: 'Lien copié',
  route_start: 'Départ',
  route_destination: 'Destination',
  route_near: 'près de {{name}}',
  route_loading: "Calcul de l'itinéraire…",
  route_loading_sub:
    "En général une ou deux secondes. Certaines zones prennent jusqu'à 30 secondes.",
  route_loading_slow: 'Calcul en cours…',
  route_loading_slow_sub: "Cette zone prend plus de temps que d'habitude.",
  route_summary_time: '{{duration}} à {{speed}}',
  route_planning_speed: 'Vitesse de planification',
  route_shoalest: "Profondeur minimale sur l'itinéraire",
  route_planning_draft: "tirant d'eau de planification",
  route_change: 'modifier',
  route_draft_title: "Tirant d'eau de planification",
  route_draft_help:
    "La profondeur pour laquelle l'itinéraire est calculé, pas le tirant d'eau de votre bateau. Plus profond, moins de passages ; moins profond, davantage.",
  route_datum: 'Profondeurs rapportées au zéro des cartes (MLLW), sans marée appliquée.',
  route_unassured_note:
    'Les tronçons orange traversent des eaux que la carte et les levés ne résolvent pas sous {{draft}}.',
  route_row_start: 'Départ {{label}}',
  route_row_heading: 'cap au {{course}}° ({{point}})',
  route_row_end: 'Arrivée {{label}}',
  route_row_end_sub: "fin de l'itinéraire",
  route_turn_left: 'Venez à gauche au {{course}}°',
  route_turn_right: 'Venez à droite au {{course}}°',
  route_bear_left: 'Venez légèrement à gauche au {{course}}°',
  route_bear_right: 'Venez légèrement à droite au {{course}}°',
  route_then: '{{first}}, puis {{second}}',
  route_keep_mark: 'Laissez la {{mark}} à votre {{hand}}',
  route_leave_channel: 'Quittez le chenal à la {{mark}}',
  route_on_your: 'à votre {{hand}} ({{side}})',
  route_hand_left: 'gauche',
  route_hand_right: 'droite',
  route_side_port: 'bâbord',
  route_side_starboard: 'tribord',
  route_mark_buoy: 'bouée {{color}} {{num}}',
  route_mark_light: 'balise lumineuse {{color}} {{num}}',
  route_mark_daybeacon: 'balise {{color}} {{num}}',
  route_mark_lighted: '{{mark}} (lumineuse)',
  route_red: 'rouge',
  route_green: 'verte',
  route_follow: 'Suivez {{name}}',
  route_follow_two: 'Suivez {{first}}, puis {{second}}',
  route_follow_channel: 'le chenal {{name}}',
  route_follow_named: 'le {{name}}',
  route_follow_unnamed: 'le chenal balisé',
  route_follow_marks: '{{count}} marques',
  route_greens_on: 'vertes à votre {{hand}}',
  route_reds_on: 'rouges à votre {{hand}}',
  route_show_marks: 'Afficher les marques',
  route_hide_marks: 'Masquer les marques',
  route_why: 'Pourquoi un virage ici ?',
  route_turn_reason: 'Vire ici car {{reason}}',
  route_lights: 'Feux à portée : {{lights}}',
  route_stretch_unassured: 'profondeur non résolue sous {{draft}}',
  route_stretch_rocky: 'entre des roches cartographiées',
  route_stretch_canal:
    "canal : manœuvre des écluses, portes et tirant d'air des ponts non modélisés",
  route_step_of: 'Étape {{n}} sur {{total}}',
  route_all_steps: 'Toutes les étapes',
  route_prev_step: 'Étape précédente',
  route_next_step: 'Étape suivante',
  route_minutes: '{{n}} min',
  route_hours: '{{h}} h',
  route_hours_minutes: '{{h}} h {{m}} min',
  route_err_on_land_origin: 'Votre point de départ est à terre sur la carte',
  route_err_on_land_destination: 'Votre destination est à terre sur la carte',
  route_err_on_land_origin_sub:
    "Faites glisser l'épingle de départ dans l'eau. Un marais, une plage ou une jetée comptent comme de la terre sur la carte.",
  route_err_on_land_destination_sub:
    "Faites glisser l'épingle de destination dans l'eau. Un marais, une plage ou une jetée comptent comme de la terre sur la carte.",
  route_err_no_route: "Aucun itinéraire avec un tirant d'eau de planification de {{draft}}",
  route_err_no_route_sub:
    "Quelque part entre les deux points, la carte indique moins de {{draft}}. Un tirant d'eau de planification plus faible peut trouver un passage.",
  route_err_no_snap: "Pas d'eau cartographiée près de l'un des points",
  route_err_no_snap_sub: 'Rapprochez les épingles des eaux libres.',
  route_err_outside: "La planification d'itinéraire couvre pour l'instant les eaux américaines",
  route_err_outside_sub:
    "Les itinéraires sont construits à partir des cartes de la NOAA : les deux points doivent donc être dans les eaux américaines. D'autres côtes suivront.",
  route_err_timeout: "Le service d'itinéraire a mis trop de temps",
  route_err_timeout_sub:
    "Certaines zones prennent jusqu'à 30 secondes et celle-ci a dépassé le délai.",
  route_err_unavailable: "La planification d'itinéraire n'est pas disponible pour le moment",
  route_err_unavailable_sub: 'Réessayez dans un instant.',
  route_err_busy: "Trop de demandes d'itinéraire",
  route_err_busy_sub: 'Patientez une minute et réessayez.',
  route_try_again: 'Réessayer',
  route_disclaimer:
    "Ne pas utiliser pour la navigation. Cet itinéraire suit le chenal balisé tel qu'il figure sur la carte ; ce n'est pas une affirmation que les eaux sont sûres.",
  route_promo_title: "Suivez cet itinéraire dans l'app avec le mode Go",
  route_promo_body:
    "Le mode Go garde votre bateau sur la carte, avec la distance jusqu'à la prochaine marque ou le prochain virage, la profondeur sous la coque, et la marée et le courant de la station la plus proche. Dans Tides Near Me pour iPhone et Android, avec un abonnement.",
}
